import { render, staticRenderFns } from "./BbbBbb001.vue?vue&type=template&id=128a6f4b&scoped=true&"
import script from "./BbbBbb001.vue?vue&type=script&lang=js&"
export * from "./BbbBbb001.vue?vue&type=script&lang=js&"
import style0 from "./BbbBbb001.vue?vue&type=style&index=0&id=128a6f4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128a6f4b",
  null
  
)

export default component.exports